module.exports = __webpack_public_path__ + "static/media/banner1_text.3b2b5b11.png";